<template>
    <div id="fiche-bu-performances-block" class=" background-quaternary-lighter text-center">
        <div class="flex text-center background-quaternary">
            <div class="col-12">
                <as-title class="color-white" :title="$t('ficheBu.detail.performances_block.title')"
                    :size="4"></as-title>
            </div>
        </div>
        <template v-if="!this.graphYearlyData || !this.graphYearlyData.length">
            <div class="mt-3 mb-3">
                <div v-if="isBusy" class="h-100 flex align-items-center">
                    <ProgressBar mode="indeterminate" style="height: 3px; max-width: 75%;" class="flex-1 m-auto">
                    </ProgressBar>
                </div>
                <template v-else>
                    <div class="flex flex-column h-100 align-items-center text-center">
                        <as-title class="mt-auto" :title="$t('ficheBu.detail.no_data_message')" :size="6"></as-title>
                        <img :src="noDataImage" class="ml-auto mr-auto mb-auto" />
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <div id="fiche-bu-performances-block__header"
                class="flex align-items-center text-center background-safety-card-border-blue color-white">
                <as-title :title="$t('ficheBu.detail.audit_block.year_tilte')" :size="5"
                    class="flex-1 color-white"></as-title>
                <span v-for="(data) in years" :key="data.year" class="flex-1 font-bold">{{ data.year }}</span>
            </div>
            <div id="fiche-bu-performances-block__tf-content" class="flex align-items-center text-center">
                <as-title :title="$t('ficheBu.detail.performances_block.tf')" :size="5" class="flex-1 color-white"></as-title>
                <span v-for="(data) in years" :key="data.year" class="flex-1 font-bold">{{ data['TF'] || '0' }}</span>
            </div>
            <div id="fiche-bu-performances-block__tg-content" class="flex align-items-center text-center">
                <as-title :title="$t('ficheBu.detail.performances_block.tg')" :size="5" class="flex-1 color-white"></as-title>
                <span v-for="(data) in years" :key="data.year" class="flex-1 font-bold">{{ data['TG'] || '0' }}</span>
            </div>
        </template>
    </div>
</template>

<script>
import AsIcon from "../Elements/AsIcon.vue";
import AsTitle from "../Elements/AsTitle.vue";
import Chip from "primevue/chip";
import ProgressBar from "primevue/progressbar";

export default {
    name: "FicheBuPerformanceBlock",
    components: {
        AsTitle,
        AsIcon,
        Chip,
        ProgressBar
    },
    props: {
        graphYearlyData: {
            type: Array,
            required: true
        },
        isBusy: Boolean
    },
    data() {
        return {
            noDataImage: new URL("../../assets/images/icons/no-data-warning.png", import.meta.url).href,
        };
    },
    computed: {
        years() {
            return this.graphYearlyData
        }
    },

};
</script>
<style lang="scss">
@import "../../assets/styles/colors.scss";

#fiche-bu-performances-block {

    &__header,
    &__tf-content {
        border-bottom: 2px solid white;
    }

    &__header,
    &__tf-content,
    &__tg-content {
        >* {
            line-height: 1.4rem !important;
        }
    }

    &__tf-content,
    &__tg-content {
        >:first-child {
            background: $quaternary_light_color !important;
        }
    }

    &__header,
    &__tf-content,
    &__tg-content {
        >*:not(:last-child) {
            border-right: 2px solid white;
            padding: 10px 0;
        }
    }
}
</style>
